// extracted by mini-css-extract-plugin
export var imageGridWrapperStyle = "section_image_grid-module--imageGridWrapperStyle--FpqR9";